import { createAction, props, union } from '@ngrx/store';
import { FilterGroupI } from './models/filter-group.interface';
import { FilterI } from './models/filter.interface';
/* eslint-disable max-len */

export const unset = createAction('[RFR ORD / Filters] Unset', props<{
  filter: FilterI;
}>());
export const update = createAction('[RFR ORD / Filters] Update', props<Record<string, unknown>>());
export const reset = createAction('[RFR ORD / Filters] Reset', props<Record<string, unknown>>());
export const set = createAction('[RFR ORD / Filters] Set', props<{
  filterGroups: FilterGroupI[];
}>());

const all = union({
  reset,
  set,
});
export type Actions = typeof all;
